export const MAX_INDIVIDUAL_PER_CASE = 30;
export const MAX_INDIVIDUAL_DUPLICATES = 10;
export const MAX_INDIVIDUAL_AGE = 100;
